import { SanitizedError } from '@mri-platform/angular-error-handling';
import { AskAgoraDDChatDataset, AskAgoraReport } from '@mri-platform/dsg/entity-state';

export function validateAskAgoraProjectedReport(report: unknown): report is AskAgoraReport {
  if (report == null || typeof report !== 'object') {
    return false;
  }

  const { reportId, report_Category, report_OrganisationWorkspace_TemplateWorkspace_Name, pbiDatasetId } =
    report as AskAgoraReport;
  return (
    typeof reportId === 'string' &&
    typeof report_Category === 'string' &&
    typeof report_OrganisationWorkspace_TemplateWorkspace_Name === 'string' &&
    typeof pbiDatasetId === 'string'
  );
}

export function validateAskAgoraDDChatDataset(dataset: unknown): dataset is AskAgoraDDChatDataset {
  if (dataset == null || typeof dataset !== 'object') {
    return false;
  }

  const { name, dataset_OrganisationWorkspace_TemplateWorkspace_Name, dataset_Category } =
    dataset as AskAgoraDDChatDataset;
  return (
    typeof name === 'string' &&
    typeof dataset_OrganisationWorkspace_TemplateWorkspace_Name === 'string' &&
    typeof dataset_Category === 'string'
  );
}

export function verifyValidItem<T>(items: T[] | SanitizedError | null): items is T[] {
  return !(items instanceof SanitizedError) && items !== null && items.length !== 0;
}
